import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import fr from './locales/fr/translation.json';
import ar from './locales/ar/translation.json';

const STORAGE_KEY = 'lang';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  ar: { translation: ar }
};

const defaultLng = 'en';
const savedLng = (() => {
  try {
    return localStorage.getItem(STORAGE_KEY) || defaultLng;
  } catch {
    return defaultLng;
  }
})();

i18n.use(initReactI18next).init({
  resources,
  lng: savedLng,
  fallbackLng: defaultLng,
  interpolation: { escapeValue: false }
});

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // ignore
  }
});

export default i18n;
